// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

:root {
  --white-smoke: #f1edee;
  --indian-red: #db5461;
  --charcoal: #3d5467;
  --dim-gray: #686963;
}

input,
button {
  appearance: none;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  color: inherit;
  background-color: inherit;
  cursor: pointer;
}

body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--charcoal);
  color: var(--white-smoke);
}

body > * {
  width: 100%;
  max-width: 1400px;
  padding: 24px;
}

header,
footer {
  flex: 0;
  height: 72px;
}

header {
  display: flex;
  gap: 60px;
}

main {
  flex: 1;
  display: flex;
  flex-direction: column;
}

section {
  flex: 1;
}

img {
  height: 56px;
  width: 56px;
}

#location {
  margin-top: 24px;
}

#weather-data {
  width: 100%;
  margin-top: 24px;
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr;
}

.weather-card {
  background-color: var(--white-smoke);
  color: #000;
  border-radius: 8px;
  box-shadow: 6px 6px 16px rgba(0, 0, 0, 0.2);
  display: grid;
  justify-items: center;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 24px 20px 40px;
}

.today {
  grid-column: 1 / -1;
  max-width: 400px;
}

.weather-card > * {
  grid-column: 1 / span 2;
}

.date {
  margin-bottom: 12px;
  font-weight: bold;
  font-size: 1.1rem;
}

.current-temp {
  font-size: 3rem;
  font-weight: bold;
}

.max-temp,
.min-temp {
  grid-column: span 1;
}

.max-temp {
  justify-self: end;
  padding-right: 12px;
}

.min-temp {
  justify-self: start;
  padding-left: 12px;
}

label {
  font-size: 1.2rem;
  margin-right: 24px;
}

input {
  background-color: var(--white-smoke);
  border: 1px solid var(--dim-gray);
  color: var(--dim-gray);
  padding: 4px 8px;
  margin-left: 4px;
}

input:focus {
  background-color: var(--dim-gray);
  color: var(--white-smoke);
}

button {
  border: 1px solid var(--white-smoke);
  padding: 8px 16px;
}

button:hover {
  background-color: var(--white-smoke);
  color: var(--indian-red);
  border-color: var(--indian-red);
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;;EAEE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,+BAA+B;AACjC","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --white-smoke: #f1edee;\n  --indian-red: #db5461;\n  --charcoal: #3d5467;\n  --dim-gray: #686963;\n}\n\ninput,\nbutton {\n  appearance: none;\n  margin: 0;\n  padding: 0;\n  border: none;\n  outline: none;\n  color: inherit;\n  background-color: inherit;\n  cursor: pointer;\n}\n\nbody {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: var(--charcoal);\n  color: var(--white-smoke);\n}\n\nbody > * {\n  width: 100%;\n  max-width: 1400px;\n  padding: 24px;\n}\n\nheader,\nfooter {\n  flex: 0;\n  height: 72px;\n}\n\nheader {\n  display: flex;\n  gap: 60px;\n}\n\nmain {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\nsection {\n  flex: 1;\n}\n\nimg {\n  height: 56px;\n  width: 56px;\n}\n\n#location {\n  margin-top: 24px;\n}\n\n#weather-data {\n  width: 100%;\n  margin-top: 24px;\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr;\n}\n\n.weather-card {\n  background-color: var(--white-smoke);\n  color: #000;\n  border-radius: 8px;\n  box-shadow: 6px 6px 16px rgba(0, 0, 0, 0.2);\n  display: grid;\n  justify-items: center;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 24px 20px 40px;\n}\n\n.today {\n  grid-column: 1 / -1;\n  max-width: 400px;\n}\n\n.weather-card > * {\n  grid-column: 1 / span 2;\n}\n\n.date {\n  margin-bottom: 12px;\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n.current-temp {\n  font-size: 3rem;\n  font-weight: bold;\n}\n\n.max-temp,\n.min-temp {\n  grid-column: span 1;\n}\n\n.max-temp {\n  justify-self: end;\n  padding-right: 12px;\n}\n\n.min-temp {\n  justify-self: start;\n  padding-left: 12px;\n}\n\nlabel {\n  font-size: 1.2rem;\n  margin-right: 24px;\n}\n\ninput {\n  background-color: var(--white-smoke);\n  border: 1px solid var(--dim-gray);\n  color: var(--dim-gray);\n  padding: 4px 8px;\n  margin-left: 4px;\n}\n\ninput:focus {\n  background-color: var(--dim-gray);\n  color: var(--white-smoke);\n}\n\nbutton {\n  border: 1px solid var(--white-smoke);\n  padding: 8px 16px;\n}\n\nbutton:hover {\n  background-color: var(--white-smoke);\n  color: var(--indian-red);\n  border-color: var(--indian-red);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
